/**
 * ImpressionistArchetype.js
 * Statistical targets for Impressionist music (Debussy, Ravel).
 * Traits: Fluidity, Color, ambiguity, Planing.
 */

import { BASE_ARCHETYPE } from './BaseArchetype.js';

export const IMPRESSIONIST_ARCHETYPE = {
    ...BASE_ARCHETYPE,

    // Harmonic Rhythm: Moderate to Slow. Chords often wash over bars.
    harmonicRhythm: {
        ...BASE_ARCHETYPE.harmonicRhythm,
        target: 1.5, // Average bars per chord (Slower changes)
        tolerance: 1.0
    },

    // Voice Distribution: Upper-Mid Focus (Shimmering textures). Light Bass.
    voiceDistribution: {
        ...BASE_ARCHETYPE.voiceDistribution,
        low: 0.15,  // Light bass foundation
        mid: 0.50,  // Warmth / Harmony
        high: 0.35, // Color / Melody / Textures (Flutes, High Strings)
        tolerance: 0.20, // Increased tolerance to accommodate Contrabass presence
        tuttiThreshold: 95 // Rarely full tutti loudness
    },

    // Dynamic Range: Subtle. "Soft Mist".
    // Not as static as Minimalist, but avoids jagged spikes.
    // Override whole object because it changes target type to 'flat'.
    dynamicRange: {
        target: 'flat', // Low standard deviation preference
        maxVariance: 0.2, // Slightly looser than Minimalist (0.1)
        minVariance: 0.0,
        weight: 0.2
    },

    // Interval Entropy: Smooth, stepwise flow.
    intervalEntropy: {
        ...BASE_ARCHETYPE.intervalEntropy,
        stepRatio: 0.60, // Target high fluidity
        stepMax: 4      // Allow Major 3rds as "Steps" (Pentatonic/Whole Tone)
    },

    // Harmonic Consonance: Tolerates "Color" dissonance (Secs, 7ths, 9ths).
    // Standard Consonance metric penalizes Maj2nds (0.8).
    // We want to be lenient.
    harmonicConsonance: {
        ...BASE_ARCHETYPE.harmonicConsonance,
        polarity: 'consonant',
        weight: 0.1 // Lower weight to allow for color tones
    }
};
